import { getStoredPreferences } from './getStoredPreferences';
import { savePreferencesToStorage } from './savePreferencesToStorage';

export const getStoredOrganizationLanguage = (
  organizationId: string,
): string | undefined =>
  getStoredPreferences().languageByOrganization?.[organizationId] || undefined;

export const saveOrganizationLanguage = (
  organizationId: string,
  language: string,
) => {
  const preferences = getStoredPreferences();
  savePreferencesToStorage({
    ...preferences,
    languageByOrganization: {
      ...preferences.languageByOrganization,
      [organizationId]: language,
    },
  });
};
